import { render, staticRenderFns } from "./Cabins.vue?vue&type=template&id=444792eb&scoped=true"
import script from "./Cabins.vue?vue&type=script&lang=js"
export * from "./Cabins.vue?vue&type=script&lang=js"
import style0 from "./Cabins.vue?vue&type=style&index=0&id=444792eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444792eb",
  null
  
)

export default component.exports